import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu,{attrs:{"close-on-content-click":false,"nudge-width":200,"bottom":"","offset-y":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VBtn,_vm._g({attrs:{"icon":"","large":""}},on),[_c(VAvatar,{attrs:{"size":"30"}},[(_vm.avatar)?_c('img',{attrs:{"src":_vm.avatar,"alt":"avatar"}}):_vm._e(),(!_vm.avatar)?_c('img',{attrs:{"src":require("@/assets/user-placeholder.png"),"alt":"avatar"}}):_vm._e()])],1)]}}])},[_c('account-manager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }